import React from 'react';

export interface SiteSectionProps {
  id?: string;
  className?: string;
  tone?: 'default' | 'muted';
  children: React.ReactNode;
}

export const SiteSection: React.FC<SiteSectionProps> = ({
  id,
  className = '',
  tone = 'default',
  children,
}) => {
  const toneClass = tone === 'muted' ? ' io-site-section--muted' : '';
  return (
    <section id={id} className={`io-site-section${toneClass} ${className}`.trim()}>
      <div className="io-site-section__inner">{children}</div>
    </section>
  );
};

export const SiteSectionHeader: React.FC<{
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}> = ({ eyebrow, title, subtitle, align = 'center' }) => (
  <header
    className={`io-site-section__header io-site-section__header--${align}`}
  >
    {eyebrow ? <p className="io-site-section__eyebrow">{eyebrow}</p> : null}
    <h2 className="io-site-section__title">{title}</h2>
    {subtitle ? <p className="io-site-section__subtitle">{subtitle}</p> : null}
  </header>
);
